class AjaxCart {
  constructor(config) {
    this.currency = config && config.currency ? config.currency : null;
    this.showCartButtons = document.querySelectorAll('[data-toggle-cart]');
    this.html = document.getElementById('ajax-cart');
    this.closeButton = this.html.querySelector('.ajax-cart__close');
    this.header = this.html.querySelector('.ajax-cart__header');
    this.controls = this.html.querySelector('.ajax-cart-controls');
    this.checkoutButton = this.html.querySelector('.ajax-cart__checkout');
    this.priceDisplay = this.html.querySelector('[data-ajax-cart-price]');
    this.noProductsContainer = this.html.querySelector('.ajax-cart__no-products');
    this.productDisplay = this.html.querySelector('[data-ajax-cart-products]');
    this.productTemplate = document.getElementById('ajax-cart-product-template');
    this.noteContainer = this.html.querySelector('[data-ajax-cart-note]');
    this.backdrop = document.querySelector('[data-cart-backdrop]');
    this.noteTextArea = this.noteContainer ? this.noteContainer.querySelector('textarea') : null;

    if (!this.productTemplate) {
      console.error('Product template not found in markup.');
      return;
    }

    this.productTemplate = this.productTemplate.cloneNode(true);
    this.productTemplate.classList.remove('hidden');
    this.productTemplate.removeAttribute('id');

    this.spinnerSVG = `
        <svg class='spinner' viewBox='0 0 50 50'>
            <circle class='path' cx='25' cy='25' r='20' fill='none' stroke-width='5'></circle>
        </svg>
    `;
    this.isVisible = false;
    this.isUpdating = false;
    this.products = [];
    this.bind();
  }

  toggleCart = () => {
    const cart = this;
    if (this.isUpdating) return;
    if (cart.isVisible) {
      cart.html.classList.remove('active');
      cart.backdrop.classList.remove('visible');
      document.querySelector('body').classList.remove('cart-active');
      cart.isVisible = false;
      removeTrapFocus(cart.html);
    } else {
      cart.showLoaders();
      cart.fetchCart();
      cart.html.classList.add('active');
      cart.backdrop.classList.add('visible');
      document.querySelector('body').classList.add('cart-active');
      cart.isVisible = true;
    }
  };

  updateCartUpsell = () => {
    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: 'ajax-cart-upsell'
        }
      ]
    });
    document.dispatchEvent(updateGlide);
  };

  showLoaders = () => {
    const cart = this;
    if (cart.priceDisplay) {
      cart.priceDisplay.innerHTML = this.spinnerSVG;
    }
    if (cart.productDisplay) {
      cart.productDisplay.innerHTML = this.spinnerSVG;
    }
    if (cart.secondaryProductDisplay) {
      cart.secondaryProductDisplay.innerHTML = this.spinnerSVG;
    }
  };

  showPriceLoader = () => {
    const cart = this;
    if (cart.priceDisplay) {
      cart.priceDisplay.innerHTML = this.spinnerSVG;
    }
  };

  fetchCart = () => {
    const cart = this;
    cart.products = [];
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.items) {
          cart.data = data;
          cart.generateCart();
          cart.updateTotal();
        } else {
          cart.data = null;
          cart.generateCart();
          cart.updateTotal();
        }

        if (p80.updateCartCount) {
          p80.updateCartCount(data.item_count);
        }
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  };

  generateCart = () => {
    const cart = this;
    cart.productDisplay.innerHTML = '';
    if (cart.data.items && cart.data.items.length) {
      for (var x = 0; x < cart.data.items.length; x++) {
        const cartItem = new AjaxCartItem(cart, cart.data.items[x]);
        cart.products.push(cartItem);
        cart.productDisplay.appendChild(cartItem.html);
      }
      cart.productDisplay.classList.remove('hidden');
      cart.noProductsContainer.classList.add('hidden');
    } else {
      cart.productDisplay.classList.add('hidden');
      cart.noProductsContainer.classList.remove('hidden');
    }
    cart.addNote();
    cart.updateCartUpsell();
    trapFocus(cart.html, cart.closeButton);
  };

  addNote = () => {
    const cart = this;
    if (!cart.noteTextArea) return;
    cart.noteTextArea.value = cart.data.note;
  };

  updateNote = () => {
    const cart = this;
    if (!cart.noteTextArea) return;
    const postData = {
      note: cart.noteTextArea.value
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((data) => {
        cart.noteTextArea.classList.remove('error');
        cart.noteTextArea.classList.add('success');
        if (cart.noteStatusTimeout) clearTimeout(cart.noteStatusTimeout);
        cart.noteStatusTimeout = setTimeout(function () {
          cart.noteTextArea.classList.remove('success');
        }, 3000);
      })
      .catch((error) => {
        cart.noteTextArea.classList.add('error');
        console.error('Error updating note:', error);
      });
  };

  getLang = () => {
    if (navigator.languages != undefined) return navigator.languages[0];
    return navigator.language;
  };

  updateTotal = () => {
    const cart = this;
    if (!cart.data.total_price) {
      cart.priceDisplay.innerHTML = '';
      cart.priceDisplay.innerText = '$0.00';
    }
    cart.priceDisplay.innerHTML = '';
    let totalPrice = cart.data.total_price;
    totalPrice = totalPrice / 100;
    totalPrice = totalPrice.toLocaleString(this.getLang(), {style: 'currency', currency: this.currency});
    cart.priceDisplay.innerText = totalPrice;

    // Broadcast cart change for the free shipping bar
    const cartChange = new CustomEvent('cartChange', {
      detail: {
        cartTotal: cart.data.total_price
      }
    });
    document.dispatchEvent(cartChange);
  };

  bind = () => {
    const cart = this;
    document.addEventListener('mousedown', function (e) {
      if (cart.isVisible) {
        if (e.target !== cart.html && !cart.html.contains(e.target)) {
          if (e.target.hasAttribute('data-toggle-cart') || e.target.closest('data-toggle-cart')) return;
          cart.toggleCart();
        }
      }
    });
    if (cart.showCartButtons.length) {
      for (var x = 0; x < cart.showCartButtons.length; x++) {
        this.showCartButtons[x].addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            cart.toggleCart();
          },
          true
        );
      }
    }

    if (cart.noteTextArea) {
      let timeout;
      cart.noteTextArea.addEventListener('keyup', function () {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
          cart.updateNote();
        }, 500);
      });
    }
  };

  enable = () => {
    const cart = this;
    cart.isUpdating = false;
    cart.checkoutButton.classList.remove('disabled');
  };

  disable = () => {
    const cart = this;
    cart.isUpdating = true;
    cart.checkoutButton.classList.add('disabled');
  };
}

class AjaxCartItem {
  constructor(cart, data) {
    this.data = data;
    this.cart = cart;
    this.currency = cart.currency;
    this.html = this.cart.productTemplate.cloneNode(true);
    this.image = this.html.querySelector('[data-ajax-cart-product-image]');
    this.title = this.html.querySelector('[data-ajax-cart-product-title]');
    this.subTitle = this.html.querySelector('[data-ajax-cart-product-subtitle]');
    this.price = this.html.querySelector('[data-ajax-cart-product-price]');
    this.quantityInput = this.html.querySelector('[data-ajax-cart-product-quantity]');
    this.quantityIncrease = this.html.querySelector('[data-ajax-cart-increase]');
    this.quantityDecrease = this.html.querySelector('[data-ajax-cart-decrease]');
    this.controls = this.html.querySelector('[data-ajax-cart-controls]');
    this.discounts = this.html.querySelector('[data-ajax-cart-product-discounts]');
    this.lineItemProperties = this.html.querySelector('[data-ajax-cart-product-lip]');
    this.isUpdating = false;
    this.generateHtml();
    this.bind();
  }

  getLang() {
    if (navigator.languages != undefined) return navigator.languages[0];
    return navigator.language;
  }

  generateHtml = () => {
    const cartItem = this;
    cartItem.image.src = cartItem.data.image;
    cartItem.title.href = cartItem.data.url;
    let title = cartItem.data.title.split(' - ');
    if (title.length) {
      title = title[0].split(' in ');
      cartItem.title.innerText = title[0];
    } else {
      cartItem.title.innerText = cartItem.data.title;
    }
    cartItem.subTitle.innerText = cartItem.data.variant_title;
    let variantPrice = cartItem.data.final_price;
    variantPrice = variantPrice / 100;
    variantPrice = variantPrice.toLocaleString(this.getLang(), {style: 'currency', currency: this.currency});
    cartItem.price.innerText = variantPrice;
    cartItem.quantityInput.value = cartItem.data.quantity;
    if (cartItem.data.discounts.length > 0) {
      cartItem.discounts.innerHTML = '';
      for (var x = 0; x < cartItem.data.discounts.length; x++) {
        const discountLine = document.createElement('div');
        let discountPrice = cartItem.data.discounts[x].amount;
        discountPrice = discountPrice / 100;
        discountPrice = discountPrice.toLocaleString(this.getLang(), {style: 'currency', currency: this.currency});
        discountLine.innerText = `${cartItem.data.discounts[x].title} (-${discountPrice})`;
        cartItem.discounts.appendChild(discountLine);
      }
    }
    if (cartItem.data.properties) {
      cartItem.lineItemProperties.innerHTML = '';

      for (var key in cartItem.data.properties) {
        if (cartItem.data.properties[key] != '' && key.charAt(0) != '_') {
          const lineItemProperty = document.createElement('div');
          lineItemProperty.innerText = key + ': ' + cartItem.data.properties[key];
          cartItem.lineItemProperties.appendChild(lineItemProperty);
        }
      }
    }
  };

  bind = () => {
    const cartItem = this;
    cartItem.quantityIncrease.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.increaseQuantity();
    });
    cartItem.quantityDecrease.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.decreaseQuantity();
    });
    cartItem.quantityInput.addEventListener('change', function (e) {
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = parseInt(value, 10);
      cartItem.updateCartItem();
    });
    cartItem.quantityInput.addEventListener('input', function (e) {
      if (cartItem.isUpdating) {
        e.preventDefault();
        return;
      }
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = parseInt(value, 10);
    });
  };

  increaseQuantity = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    cartItem.data.quantity = cartItem.data.quantity + 1;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  decreaseQuantity = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    if (cartItem.data.quantity <= 0) return;
    cartItem.data.quantity = cartItem.data.quantity - 1;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  updateCartItem = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    cartItem.isUpdating = true;
    cartItem.disable();
    cartItem.cart.disable();
    cartItem.cart.showPriceLoader();
    const variantId = cartItem.data.variant_id;
    const quantity = cartItem.data.quantity;
    const postData = {
      updates: {
        [variantId]: quantity
      }
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((data) => {
        cartItem.enable();
        cartItem.cart.enable();
        if (data.items && data.items.length) {
          cartItem.cart.productDisplay.classList.remove('hidden');
          cartItem.cart.noProductsContainer.classList.add('hidden');
          cartItem.cart.data = data;
          cartItem.cart.updateTotal();
          const newData = data.items.filter(function (item) {
            return item.variant_id === variantId;
          });
          if (newData.length) {
            cartItem.data = newData[0];
            cartItem.generateHtml();
          } else {
            cartItem.removeItem();
          }
        } else {
          cartItem.cart.data = data;
          cartItem.cart.updateTotal();
          cartItem.cart.productDisplay.classList.add('hidden');
          cartItem.cart.noProductsContainer.classList.remove('hidden');
        }
        cartItem.cart.updateCartUpsell();
        if (p80.updateCartCount) {
          p80.updateCartCount(data.item_count);
        }
      })
      .catch((error) => {
        cartItem.enable();
        cartItem.cart.enable();
        console.error('Error fetching cart:', error);
      });
  };

  removeItem = () => {
    const cartItem = this;
    const itemKey = cartItem.cart.products.findIndex((product) => {
      return product.data.variant_id === cartItem.data.variant_id;
    });
    if (itemKey >= 0) {
      cartItem.cart.products.splice(itemKey, 1);
      cartItem.html.remove();
    }
  };

  enable = () => {
    const cartItem = this;
    cartItem.isUpdating = false;
    cartItem.controls.classList.remove('disabled');
  };

  disable = () => {
    const cartItem = this;
    cartItem.isUpdating = true;
    cartItem.controls.classList.add('disabled');
  };
}
